export default {
    render(){},
    props: {
        props_product: {
            required: true
        }
    },
    data() {
        return {
            product: JSON.parse(this.props_product)
        }
    },
    mounted() {
        window.dataLayer = window.dataLayer || []
        dataLayer.push(this.object);
    },
    computed: {
        object() {
            let object = {
                'event': 'view_item',
                'value': this.product.price_finaly, // цена товара со скидкой
                'items':[{
                    'id': this.product.code, // Код товара (именно код, а не ID)
                    'google_business_vertical': 'retail'
                }]
            };
            return object;
        }
    }
}
